module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.8061fa13b696a0bcfe46.js");
}
